import React from "react";
import CardComponent from "./CardComponent";
import "../FBOHome.css";

const GridComponent = ({ gridItems, onClickCard }) => {
  const cellLength = gridItems?.length < 3 ? gridItems?.length : 3;

  return (
    <div
      className="fbo-grid-container"
      style={{ gridTemplateColumns: `repeat(${cellLength}, 1fr)` }}
    >
      {gridItems.map((item, index) => (
        <CardComponent
          key={index}
          item={item}
          onClickCard={() => onClickCard(index)}
        />
      ))}
    </div>
  );
};

export default GridComponent;
